import React, { useMemo, useState } from 'react';
import CandidateList from './list/CandidateList';
import Overview from './overview/Overview';
import { useFindRecruiterCandidateQuery } from 'service/recruiterQuery/recruiterQuery';
import { useParams } from 'react-router-dom';
import { Col, Spinner } from 'react-bootstrap';
import { CandidateProfile, CandidateProfiles } from './candidateOverview.type';
import Empty from 'components/base/Empty';

function CandidateOverview() {
  const { search } = useParams();
  const { isLoading, data } = useFindRecruiterCandidateQuery({ search });
  const [selectedData, setSelectedData] = useState<CandidateProfile | null>(
    null
  );
  const selecedCandidate = useMemo(() => {
    return selectedData || (data as CandidateProfiles)?.[0];
  }, [selectedData, data]);

  return isLoading ? (
    <Col xs={12}>
      <div className="d-flex justify-content-center w-100">
        <Spinner animation="border" role="status" className="me-2">
          <span className="visually-hidden">Loading...</span>
        </Spinner>
      </div>
    </Col>
  ) : Array.isArray(data) && data.length === 0 ? (
    <Col xs={12}>
      <div className="d-flex justify-content-center align-items-center flex-column gap-4 w-100">
        <Empty />
        <h3 className="text-body-tertiary">No matching records found.</h3>
      </div>
    </Col>
  ) : (
    <>
      <CandidateList
        data={data as CandidateProfiles}
        setSelectedData={setSelectedData}
        selectedItem={selectedData?._id}
      />
      <Overview data={selecedCandidate} />
    </>
  );
}

export default CandidateOverview;
